import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useQuery, useMutation, useQueryClient } from "react-query";
import env from "../../environment";

export function useLOSDetailGet({ month, year, ibo }) {
  // console.log("API Base:", env.apiBase);

  const { data, isLoading, refetch } = useQuery(
    ["losDetail", month, year, ibo],
    () =>
      makeAuthedRequest(
        `/los/detail/ibo/${ibo}/year/${year}/month/${month}`,
        {
          method: "GET",
        },
        env.apiBaseNew
      ).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error((await res.json()).message);
        }
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: !!ibo,
    }
  );

  return {
    data,
    isLoading,
    refetch,
  };
}
